import { Registry } from '../../../docs/registries/schema';

const getSelectedAndDepsRegistries = (
  selectedRegistries: Registry[],
  allRegistries: Registry[]
) => {
  const selectedAndDepRegistries: Registry[] = selectedRegistries;

  const getter = (registries: Registry[]) => {
    registries.forEach((registry) => {
      if ((registry.registryDependencies ?? []).length) {
        const dependencyNameNotYetInList =
          registry.registryDependencies?.filter((dependencyName) => {
            return !selectedAndDepRegistries.some(
              (r) => r.name === dependencyName
            );
          });
        const dependencyNameNotYetInListRegistries =
          dependencyNameNotYetInList?.map((dependencyName) => {
            return allRegistries.find(
              (registry) => registry.name === dependencyName
            )!;
          });
        selectedAndDepRegistries.push(
          ...(dependencyNameNotYetInListRegistries ?? [])
        );
        getter(dependencyNameNotYetInListRegistries ?? []);
      }
    });
  };

  getter(selectedRegistries);
  return selectedAndDepRegistries;
};

export default getSelectedAndDepsRegistries;
